import { Button } from 'components/Button'
import { ReviewType } from 'api/clients/InformalFeedbackRequestsClient'
import Styles from './KeyActionButton.module.scss'
import cx from 'classnames'
import { ButtonProps } from 'components/Button/Types'

export const colorByType = (reviewType: ReviewType) => {
  switch (reviewType) {
    case ReviewType.Approval:
      return Styles.typeApproval
    case ReviewType.Suggestion:
      return Styles.typeSuggestion
    case ReviewType.ReadReceipt:
      return Styles.typeReadReceipt
    default:
      return Styles.typeReview
  }
}

export interface KeyActionButtonProps extends Pick<ButtonProps, 'isDisabled' | 'onPress'> {
  reviewType: ReviewType
  label: string
}

export const KeyActionButton = ({ reviewType, label, onPress: handleOnPress, isDisabled }: KeyActionButtonProps) => {
  return (
    <Button
      className={cx(Styles.keyActionButton, colorByType(reviewType))}
      size="md"
      variant="secondary"
      onPress={handleOnPress}
      isDisabled={isDisabled}
    >
      {label}
    </Button>
  )
}
